var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ranking-chart",style:({height:_vm.HEIGHT+'px'}),attrs:{"id":"ranking"}},[_c('span',{staticClass:"homepage-title"},[_vm._v("运营类型")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-box"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"ranking-chart"}})])
}]

export { render, staticRenderFns }